export default __webpack_public_path__ + "static/SuisseWorks-Regular-WebS-f746ac6a424d4cd10c4e12071dbcc8bd.woff";